<template>
    <v-card color="white" >
            <v-list >
                <template v-for="(item, index) in listItems">
                    <v-divider v-if="item.divider" :key="index" />
                    <v-list-tile v-if="item.content && item.to" :key="item.content" :to="item.to">
                        <v-list-tile-content class="black--text">
                            {{item.content}}
                     </v-list-tile-content>

                    </v-list-tile>
                </template>
            </v-list>
          </v-card>
</template>

<script>
export default {
  data () {
    return {
      show: true,
      listItems: []
    }
  },

  mounted () {
    this.createListItems()
  },

  methods: {
    createListItems () {
      this.listItems = [
        { content: this.$t('menu.createDiagno'), to: '/create/diagno' },
        { divider: true },
        { content: this.$t('menu.uploadMedia'), to: '/create/video' },
        { divider: true },
        { content: this.$t('menu.article'), to: '/create/article' }
      ]
    }

  }

}
</script>
